module.exports = __webpack_public_path__ + "static/media/advantages-background.2756fce2.png";